import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=2b376337&scoped=true&"
import script from "./FaqModal.vue?vue&type=script&lang=js&"
export * from "./FaqModal.vue?vue&type=script&lang=js&"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=2b376337&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b376337",
  null
  
)

export default component.exports